import Axios from 'axios';
import { API_URL } from '../../../lib/const';


const createEmailBatch = params => Axios.post(`${API_URL}/tasks/email-batches`, params)
  .then(response => response.data);

export default createEmailBatch;
